module.exports = __webpack_public_path__ + "images/backgrounds/river/large.801d937c765a9996d4ec.jpg";